import React from 'react';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';
import { ServerStyleSheet } from 'styled-components';
import { RecordingViewState } from './RecordingViewState';
import { ReportRouterView } from './RecordingView';
import { fileNameSafeString } from '../../lib/utils/fileNameSafeString';
import { ReportTitle, ReportSubtitle } from './common-styles';
// import { generateStandaloneDynamicSearchReport } from '../../lib/Reports/generateStandAloneSearchReport';
import { UUID } from '../../State/EvidenceDB/DatabaseTypes';

const html = String.raw;

export const downloadReport = (recordingViewState: RecordingViewState) => {
	const div = document.createElement('div');
	const sheet = new ServerStyleSheet();
	const root = createRoot(div);
	flushSync(() => {
		root.render(sheet.collectStyles(<>{recordingViewState.topTab !== 'search' ? null : (<>
					<ReportTitle>{recordingViewState.recordingNameOrDescription}</ReportTitle>
					<ReportSubtitle>{recordingViewState.reportBaseName}</ReportSubtitle>
				</>)}
				<ReportRouterView {...{recordingViewState}} />
		</>
		));
	});
	const x = sheet.getStyleTags();
	const reportHtml = html`<!DOCTYPE html>
<html lang="en" xml:lang="en" xmlns= "http://www.w3.org/1999/xhtml">
	<meta charset="UTF-8">
	<meta name="google" content="notranslate">
	<meta http-equiv="Content-Language" content="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${recordingViewState.reportFullName}</title>
		${sheet.getStyleTags()}
  </head>
  <body>
		${div.outerHTML}
  </body>
	</html>
	`
	chrome.downloads.download({
		url: URL.createObjectURL(new Blob([reportHtml], {type: 'text/html'})),
		filename: `${fileNameSafeString(recordingViewState.reportFullName)}.html`,
		saveAs: true
	});
}

// export const downloadStandaloneSearchReportFn = (recordingViewState: RecordingViewState)=> async()  => {
// 	const reportHtml = await generateStandaloneDynamicSearchReport(recordingViewState.recordingUuid, {
// 		title: recordingViewState.reportFullName,
// 	});
// 	chrome.downloads.download({
// 		url: URL.createObjectURL(new Blob([reportHtml], {type: 'text/html'})),
// 		filename: `${fileNameSafeString(`${recordingViewState.recordingNameOrDescription} Live Search`)}.html`,
// 		saveAs: true
// 	})
// };